<div class="template-text-wrapper pt-4">
    <div class="text-center">
        <h3>{{template.sysTemplateTypeDescription}}</h3>
    </div>
    <button class="btn mb-3 btn-outline-primary" (click)="templateOpen = false; templateOpenChange.emit(templateOpen)"><i class="fa fa-angle-left"></i> BACK TO TEMPLATES</button>
    <div class="templates-text">
        <div class="success-message" *ngIf="subjectAlertVisible">
            <p class="mb-0">Subject Copied!</p>
        </div>
        <div class="success-message" *ngIf="!template.subject">
            <p>No subject added yet!</p>
        </div>
        <p *ngIf="!subjectAlertVisible && template.subject" [innerHtml]="template.subject | newline" class="mb-0"></p>
    </div>
    <div class="d-flex justify-content-end mb-4" *ngIf="template.subject">
        <button class="btn btn-primary" style="min-width: 150px" (click)="copySubjectToClipboard()">
            <span *ngIf="!subjectAlertVisible">Copy Subject</span>
            <i class="fa fa-check" *ngIf="subjectAlertVisible"></i>
        </button>
    </div>
    <div class="templates-text">
        <div class="success-message" *ngIf="messageAlertVisible">
            <p>Message Copied!</p>
            <p class="mb-0">Now paste it into your personal email</p>
        </div>
        <div class="success-message" *ngIf="!template.content">
            <p>No template added yet!</p>
        </div>
        <p *ngIf="!messageAlertVisible && template.content" [innerHtml]="template.content | newline"></p>
    </div>
    <div class="row justify-content-between" *ngIf="template.content">
        <div class="col-12 col-sm-auto mb-3 mb-sm-0 text-center">
            <a (click)="openMessage(content)">What do I do here?</a>
        </div>
        <div class="col-12 col-sm-auto">
            <button class="btn btn-primary" style="min-width: 150px" (click)="copyMessageToClipboard()">
                <span *ngIf="!messageAlertVisible">Copy Text</span>
                <i class="fa fa-check" *ngIf="messageAlertVisible"></i>
            </button>
        </div>
    </div>
</div>

<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-body p-4">
        <div class="text-center">
            <h3>Copy Email</h3>
            <p>Copy and paste this message into your personal email account.</p>
            <p>Email sent from personal accounts has proven to be the best source of donations.</p>
            <button type="button" class="btn btn-outline-dark btn-primary" (click)="c()">OK, GOT IT</button>
        </div>
    </div>
</ng-template>

